module.exports = __webpack_public_path__ + "static/media/xamarin.5a1d6813.jpg";